import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Guarantee() {
  return <section className="w-full bg-white px-4 py-12 sm:px-6 sm:py-16" data-id="element-137" data-mp="1o2vjmvsbez9q">
      <div className="mx-auto max-w-2xl" data-id="element-138" data-mp="223oejhmj3wdd">
        <div className="rounded-2xl border border-teal/25 bg-teal-light/50 p-6 text-center" data-id="element-139" data-mp="222n156i1ixsh">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-teal" data-id="element-140" data-mp="1x54qnbodkaid">
            <ShieldCheckIcon className="h-7 w-7 text-white" aria-hidden="true" data-id="element-141" data-mp="19f0ol8qu4ith" />
          </span>
          <h2 className="mt-4 font-serif text-[26px] font-bold leading-tight text-navy-900 sm:text-3xl" data-id="element-142" data-mp="1j4afwmdutxgj">
            Tu inversión está completamente protegida
          </h2>
          <p className="mt-4 text-[14.5px] leading-relaxed text-navy-900/80" data-id="element-143" data-mp="1ebr33rmzr6cs">
            Sabemos que comprar un recurso digital siempre genera una pregunta:
            <em className="block font-serif text-[16px] text-navy-900" data-id="element-144" data-mp="lo528r55eftm">
              “¿Y si no era lo que esperaba?”
            </em>
          </p>
          <p className="mt-4 text-[14.5px] leading-relaxed text-navy-900/80" data-id="element-145" data-mp="oxozxwaj2uxq">
            Por eso eliminamos ese riesgo. Dispones de{' '}
            <strong data-id="element-146" data-mp="yp2wpwb3hgn6">7 días de garantía</strong>. Si consideras que la Ruta
            Clínica GLP-1 no aporta claridad a tus decisiones, no te ayuda a
            ahorrar tiempo en consulta o no cumple tus expectativas, solo debes
            escribirnos y te devolveremos el 100% de tu dinero.
          </p>
          <p className="mt-4 text-[13px] font-bold uppercase tracking-wide text-teal" data-id="element-147" data-mp="b0rzd34lxz3n">
            Sin formularios interminables · Sin explicaciones incómodas · Sin
            riesgo para ti
          </p>
        </div>

        <div className="mx-auto mt-8 max-w-md" data-id="element-148" data-mp="k1zwvizauvwo">
          <CTAButton label="Probar sin riesgo por 7 días" note="Si no es para ti, te devolvemos el 100%" data-id="element-149" data-mp="1qgr3m3b3taym" />
        </div>
      </div>
    </section>;
}